import { Icon } from '@chakra-ui/react';

export const ScaleQuestion = (props) => (
  <Icon viewBox="0 0 20 20" boxSize="16px" color="icon.g1" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.81481 3.3335H15.1852C16 3.3335 16.6667 4.00016 16.6667 4.81498V10.1853C16.6667 11.0002 16 11.6668 15.1852 11.6668H4.81481C4 11.6668 3.33333 11.0002 3.33333 10.1853V4.81498C3.33333 4.00016 4 3.3335 4.81481 3.3335ZM4.81481 10.1853H6.12508V8.3335H7.20841V10.1853H7.79175V7.50016H8.87508V10.1853H9.45841V8.3335H10.5417V10.1853H11.1251V7.50016H12.2084V10.1853H12.7917V8.3335H13.8751V10.1853H15.1852V4.81498H4.81481V10.1853Z"
      fill="currentColor"
    />
    <path
      d="M16.6421 14.9368C16.6748 14.9718 16.6748 15.0285 16.6421 15.0636L15.169 16.6404C15.1162 16.6969 15.026 16.6569 15.026 16.577V15.583H4.97398V16.577C4.97398 16.6569 4.88375 16.6969 4.83098 16.6404L3.35787 15.0636C3.32515 15.0285 3.32515 14.9718 3.35787 14.9368L4.83098 13.3599C4.88375 13.3035 4.97398 13.3435 4.97398 13.4233V14.4173H15.026V13.4233C15.026 13.3435 15.1163 13.3035 15.169 13.3599L16.6421 14.9368Z"
      fill="currentColor"
    />
  </Icon>
);
